<template>
	<el-container style=" border: 1px solid #eee">
	  <el-main>
		<!-- 添加搜索框 -->
		<el-input v-model="searchText" placeholder="请输入关键词进行搜索" clearable @input="handleSearch"></el-input>
		<el-table :data="filteredTableData">
			
			<el-table-column prop="id" label="ID" width="50"></el-table-column>
			<el-table-column prop="reMark" label="设备名称" width="250"></el-table-column>
			<el-table-column prop="deviceId" label="设备ID" width="250"></el-table-column>
			<el-table-column prop="tips" label="备注" width="250"></el-table-column>
			
			<el-table-column prop="onlineState" label="在线状态" width="100">
				<template slot-scope="scope">
				<span :class="scope.row.onlineState === '在线'? 'online-dot' : 'offline-dot'"></span><span style="margin-left: 5px;">{{scope.row.onlineState}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="lastTime" label="最后上线时间" width="250"></el-table-column>
			<el-table-column prop="registerInfo" label="注册信息" width="250"></el-table-column>
			<el-table-column prop="registerCode" label="注册码" width="600"></el-table-column>
			<el-table-column prop="creatTime" label="注册时间" width="200"></el-table-column>
			<el-table-column fixed="right" label="操作" width="220">
				<template slot-scope="scope">
				<el-button type="danger" size="small" @click="deleteById(scope.row)" style="margin-left: 10px;">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!-- 新增复选框选择的模态框 -->
<el-dialog title="批量注册" :visible.sync="batchDialogVisible" width="50%">
       
	   <el-form ref="ruleAllForm" :model="ruleAllForm":rules="rules" label-width="80px">
		   <el-form-item label="授权类型" prop="type">
			   <el-select v-model="ruleAllForm.type" placeholder="请选择授权类型">
				   <el-option label="永久" value="forever"></el-option>
				   <el-option label="天数" value="day"></el-option>
				   <el-option label="次数" value="frequency"></el-option>
			   </el-select>
		   </el-form-item>
		   <el-form-item  v-if="ruleAllForm.type=='day'" label="授权天数"  >
			   <el-date-picker prop="day"
				   v-model="value1"
				   type="datetime"
				   placeholder="选择结束日期时间">
				   prop="day"
			   </el-date-picker>
		   </el-form-item>
		   <el-form-item  v-if="ruleAllForm.type=='frequency'" label="授权次数" >
			   <el-input v-model="ruleAllForm.time" placeholder="请输入授权次数" ></el-input>
		   </el-form-item>
		  
		   <el-form-item >
			   <el-button @click="batchDialogVisible = false">取 消</el-button>
				   <el-button type="primary" @click="submitForm('ruleAllForm')">确 定</el-button>
		   </el-form-item> 
	   </el-form>
	   
   </el-dialog>

	<!-- 返回注册码弹出框 -->
	<el-dialog title="注册码" :visible.sync="dialogV" width="70%">
	 <el-table :data="codeList" style="width: 100%">
	   <el-table-column prop="deviceId" label="设备ID" width="300"></el-table-column>
	   <el-table-column prop="registerCode" label="注册码"  width="800"></el-table-column>
	 </el-table>
	 <span slot="footer" class="dialog-footer">
	   <el-button @click="dialogV = false">关闭</el-button>
	 </span>
   </el-dialog>
	  </el-main>
	  <el-footer>
		<!-- ===分页===== -->
		<el-pagination
		  @size-change="handleSizeChange"
		  @current-change="handleCurrentChange"
		  :current-page="currentPage"
		  :page-sizes="[5, 10, 15, 20]"
		  :page-size="5"
		  layout="total, sizes, prev, pager, next, jumper"
		  :total="totalPage">
		</el-pagination>
		<br/>
		<el-button v-if="this.ruleAllForm.selectedIds.length > 0"  type="warning" @click="batchRegister()" size="small" >批量注册</el-button>
	  </el-footer>
	</el-container>
  </template>
  
  <style>
	* {
	  margin: 0;
	  padding: 0;
	}
  
   .online-dot {
	  display: inline-block;
	  width: 5px;
	  height: 5px;
	  background-color: rgb(0, 255, 0);
	  border-radius: 50%;
	}
  
   .offline-dot {
	  display: inline-block;
	  width: 5px;
	  height: 5px;
	  background-color: gray;
	  border-radius: 50%;
	}
  
   .el-header {
	  background-color: #B3C0D1;
	  color: #333;
	  line-height: 60px;
	}
  
   .el-aside {
	  color: #333;
	}
  </style>
  
  <script>
  import Axios from 'axios'
  export default {
	data() {
	  return {
		
		searchText: '', // 用于存储搜索关键词
		tableData: [],
		filteredTableData: [], // 存储过滤后的表格数据
		currentPage: 1,
		pageSize: 5,
		total: 0,
		batchDialogVisible: false,
		dialogV: false,
		codeList: {

		},
		ruleAllForm: {
            type: '',
            time:'',
            startTime:'',
            endTime:'',
            selectedIds: [],
            creatTime:''
          
          },
		  rules: {
            
            type: [
              { required: true, message: '请选择授权类型', trigger: 'change' }
            ],
            day:[
            { required: true, message: '请输入授权天数', trigger: 'blur' }
            ],
           
            
           
          },
		info: {
		  id: '',
		  deviceId: '',
		  tips:'',
		  lastTime:'',
		  registerCode: '',
		  createTime: '',
		  registerInfo: '',
		  remark: '',
		  position: ''
		}
	  }
	},
	created() {
	  this.fetchData();
	  this.filteredTableData = this.tableData; // 初始化过滤后的数据
	},
	mounted: {
  
	},
	methods: {
		batchRegister() {
            this.batchDialogVisible = true;
        },
	  fetchData() {
		this.request.get('/getRegisterDeviceInfo', {
		  params: {
			page: this.currentPage,
			pageSize: this.pageSize
		  }
		})
	  .then(response => {
		  this.tableData = response.info;
		  this.filteredTableData = response.info; // 获取数据时同时更新过滤后的数据初始值
		  this.total = response.total;
		})
	  .catch(error => {
		  console.error(error);
		});
	  },
	  // 改变每页条数
	  handleSizeChange(size) {
		this.pageSize = size;
		this.fetchData();
	  },
	  // 改变页数
	  handleCurrentChange(page) {
		this.currentPage = page;
		this.fetchData();
	  },
	  show(e) {
		this.info = e;
	  },
	  deleteById(e) {
		this.$confirm('确认删除本条用户记录？').then(_ => { this.delete(e.id) }).catch(_ => {});
	  },
	  delete(i) {
		this.request.get('/deleteRegisterDeviceById', { params: { "ID": i } }).then(response => {
		  if (response.code == "0") {
			this.$message({ message: '删除成功', type: 'success' });
			this.fetchData();
		  } else {
			this.$message.error('删除失败');
		  }
		}).catch(error => { console.log(error) });
	  },
	  // 处理搜索逻辑的方法
	  handleSearch() {
		const searchText = this.searchText.trim().toLowerCase(); // 获取去除空格并转为小写的搜索关键词
		if (searchText === '') {
		  this.filteredTableData = this.tableData; // 如果关键词为空，显示全部数据
		  return;
		}
		this.filteredTableData = this.tableData.filter(item => {
		  return Object.values(item).some(value => {
			if (typeof value ==='string') {
			  return value.toLowerCase().includes(searchText); // 对每一行数据的每个属性值（如果是字符串类型）进行模糊匹配
			}
			return false;
		  });
		});
	  }
	},
	
	
	
	submitForm(formName) {
         
         	this.$refs[formName].validate((valid) => {
           if (valid) {
             if(this.ruleAllForm.time=="" && this.ruleAllForm.type=="frequency"){
               this.$message.error("请输入授权次数");
             }else if( this.ruleAllForm.selectedIds.length<=0){
                this.$message.error("请勾选注册设备");
             }else{

               const timestamp = new Date().getTime();
               const date = new Date(timestamp);
               this.ruleAllForm.creatTime= date.toLocaleString();
               if(this.ruleAllForm.type=="day"){
                 const timestamp1 =this.value1.getTime();
                 const date1 = new Date(timestamp1);
                 this.ruleAllForm.endTime=date1.toLocaleString()
               }
               console.log('准备批量注册的设备ID:', this.ruleAllForm.selectedIds);

               const loading = this.$loading({
          lock: true,
          text: '正在注册',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
       
               this.request.post("/DeviceAllRegister", this.ruleAllForm).then(res => {
                if(res.code=='0'){
                      this.$message({message: '设备授权成功',type: 'success'});
                      console.log(res);
                      loading.close();
                      this.ruleAllForm.selectedIds=[];
                      this.codeList =JSON.parse(res.registerCode);
                      this.batchDialogVisible = false;
                      this.dialogV=true;
                     
                 }else{
                      this.$message.error(res.msg);
                      this.batchDialogVisible = false;
                      this.ruleAllForm.selectedIds=[];
                }
            })
           
             }
              
           } else {
             console.log('error submit!!');
             return false;
           }
         });
       },
  };
  </script>